import React, { Component } from 'react';
import { Form, reduxForm } from 'redux-form';
import Button from '../../../../components/Button';
import { FormField } from '../../../../components/CustomForm';
import PaddingBox from '../../../../components/PaddingBox';
import TextboxAdapter from '../../../../components/adapters/form/Textbox';
import { codes } from '../../../../data/translations';
import { length, required } from '../../../../utils/formValidators';
import { email } from '../../../../utils/formValidators';
import { FORM_FORGOT_PASSWORD_NAME } from '../../consts';

@reduxForm({
	form: FORM_FORGOT_PASSWORD_NAME,
})
export class AuthenticationForgotPasswordForm extends Component {
	render() {
		const { handleSubmit, translate } = this.props;

		return (
			<Form onSubmit={handleSubmit}>
				<FormField
					component={TextboxAdapter}
					name='email'
					validate={[required(), email(), length({ max: 128 })]}
					controlProps={{ label: translate(codes.common.email), isRequired: true }}
					componentProps={{ placeholder: 'example@gmail.com', autoFocus: true }}
				/>
				<PaddingBox topSmall>
					<Button
						type='submit'
						primary
						block
						size='small'
					>
						{translate(codes.common.send)}
					</Button>
				</PaddingBox>
			</Form>
		);
	}
}
